import { InFilterDefinition } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

export const useMyReporteesFilter = (): InFilterDefinition<string> => {
  return {
    label: i18n.t('employees.employees_list.filters.my_reportees'),
    type: 'in' as const,
    options: {
      cache: true,
      options: async () => [
        {
          label: i18n.t('employees.employees_list.filters.my_reportees_options.direct'),
          value: 'direct',
        },
        {
          label: i18n.t('employees.employees_list.filters.my_reportees_options.all'),
          value: 'all',
        },
      ],
    },
  }
}
